/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use, useClient } from 'fierry/react';

import HexGeometry from 'solis/react/board/geometry/hex';
import ZoneGeometry from 'solis/react/board/geometry/zone';

import Center from 'solis/react/board/hex/center';
import HexRing from 'solis/react/board/highlights/hex.ring';


// A standalone hex (all borders external) so the ring renders the full hexagon.
class MarkerZone
{
  constructor (hex, color)
  {
    this.hex = hex;
    this.color = color;
  }


  getNeighbor ()
  {
    return null;
  }


  getNeighbors ()
  {
    return [ null, null, null, null, null, null ];
  }


  isExternalBorder ()
  {
    return true;
  }


  isGroupBorder ()
  {
    return false;
  }


  getDisplayHex ()
  {
    return this.hex;
  }


  getEntityHex ()
  {
    return this.hex;
  }


  getColor ()
  {
    return this.color;
  }
}


const Marker = ({ hex, color }) =>
{
  const hexGeometry = use(HexGeometry);

  const zoneData = new MarkerZone(hex, color);
  const zoneGeometry = useClient(ZoneGeometry, { zoneData, hexGeometry });

  return (
    <Center zoneData = {zoneData} hexGeometry = {hexGeometry}>
      <HexRing hexGeometry = {hexGeometry} zoneGeometry = {zoneGeometry} />
    </Center>
  );
};


export default ({ hexes, color }) =>
(
  <g style = {{ pointerEvents: 'none' }}>
    {hexes.toArray().map(hex => <Marker key = {hex.toString()} hex = {hex} color = {color} />)}
  </g>
);
